import { useTranslation, Trans } from 'react-i18next'
import { useModalOpened, useModalToggle } from '~/state/application/hooks'
import { ApplicationModal } from '~/state/application/reducer'
import Modal from '../Modal'
import { LOCALES } from '~/locales'
import ProgressiveImg from '~/components/ProgressiveImg'
import {
  Container,
  StyledTitle,
  Content,
  StyledButton,
  StyledItemContainer,
  StyledIcon,
  StyledItemTitle,
  StyledItemDesc,
  StyledNote,
  StyledLink,
} from './styled'
import PicGuideEN from '~/assets/images/set-spotswap-pay-mode-guide-en.gif'
import PicGuideZH from '~/assets/images/set-spotswap-pay-mode-guide-zh.gif'
import PlaceholderImgEN from '~/assets/images/set-spotswap-pay-mode-guide-en-placeholder.png'
import PlaceholderImgZH from '~/assets/images/set-spotswap-pay-mode-guide-zh-placeholder.png'
import IConFeat1 from '~/assets/images/pay_with_token_modal_feature_icon_1.svg'
import IConFeat2 from '~/assets/images/pay_with_token_modal_feature_icon_2.svg'
import IConFeat3 from '~/assets/images/pay_with_token_modal_feature_icon_3.svg'

const PayWithTokensIntroModal = () => {
  const { t, i18n } = useTranslation()
  const toggle = useModalToggle(ApplicationModal.PAY_WITH_TOKENS_INTRO)
  const isOpen = useModalOpened(ApplicationModal.PAY_WITH_TOKENS_INTRO)

  const isZh = i18n.resolvedLanguage === LOCALES.ZH
  const lang = isZh ? 'zh-cn' : 'en-us'
  const link = `https://support.tokenlon.im/hc/${lang}/articles/4469475589268`

  const PicGuide = isZh ? PicGuideZH : PicGuideEN
  const PlaceholderImg = isZh ? PlaceholderImgZH : PlaceholderImgEN

  const features = [
    {
      icon: IConFeat1,
      title: 'payWithTokensIntroModal.feature_1_title',
      desc: 'payWithTokensIntroModal.feature_1_desc',
    },
    {
      icon: IConFeat2,
      title: 'payWithTokensIntroModal.feature_2_title',
      desc: 'payWithTokensIntroModal.feature_2_desc',
    },
    {
      icon: IConFeat3,
      title: 'payWithTokensIntroModal.feature_3_title',
      desc: 'payWithTokensIntroModal.feature_3_desc',
    },
  ]

  return (
    <Modal
      isOpen={isOpen}
      onDismiss={toggle}
      animate={false}
      contentClassName="pay-with-tokens-intro"
    >
      <Container>
        <StyledTitle>{t('payWithTokensIntroModal.title')}</StyledTitle>
        <ProgressiveImg
          src={PicGuide.src}
          placeholderSrc={PlaceholderImg.src}
          width={315}
          height={78.75}
          style={{ border: '16px' }}
          alt="guide"
        />
        <Content>
          <div>
            {features.map(({ icon, title, desc }, index) => (
              <StyledItemContainer key={index}>
                <StyledIcon src={icon} />
                <div>
                  <StyledItemTitle>{t(title)}</StyledItemTitle>
                  <StyledItemDesc>{t(desc)}</StyledItemDesc>
                </div>
              </StyledItemContainer>
            ))}
          </div>
          <StyledNote>
            <Trans i18nKey="payWithTokensIntroModal.note">
              注：卖出 ETH 时，此功能将会失效，
              <StyledLink href={link} target="_blank">
                了解更多。
              </StyledLink>
            </Trans>
          </StyledNote>
        </Content>
        <StyledButton onClick={toggle}>{t('ok')}</StyledButton>
      </Container>
    </Modal>
  )
}

export default PayWithTokensIntroModal
